/**
 * Helper: Format money
 * -----------------------------------------------------------------------------
 * Formats money into store format.
 *
 * @param {Number} value - Value in cents.
 * @param {Object} [config] - Config object.
 * @param {String} [config.format] - Money format.
 * @param {Boolean} [config.removeZeros] - Remove trailing zeros.
 * @param {Boolean} [config.round] - Round price up and remove zeros.
 * @returns {String}
 *
 */
import { formatMoney } from '@we-make-websites/theme-currency'

export default (value, {
  format = cnvs.store.moneyFormat,
  removeZeros = false,
  round = false,
} = {}) => {
  if (round) {
    const updatedValue = Math.ceil(value / 100) * 100
    return formatMoney(updatedValue, format, true)
  }

  return formatMoney(value, format, removeZeros)
}
